module.exports = __webpack_public_path__ + "static/media/empyt-image.3295b015.svg";